<template>
    <div class="content">
        <div class="button">
            <van-field
                    v-model="titleTimeStart"
                    placeholder="选择开始时间" readonly="readonly"
                    @click="dateShowStart = true"
            />
            <van-field
                    v-model="titleTime"
                    placeholder="选择结束时间" readonly="readonly"
                    @click="dateShow = true"
            />
            （开始结束时间必填，最多只返回100条）
            <div class="table-box" v-if="runtimeData.page&&runtimeData.page.length>0">
                <table width="100%">
                    <tr v-for="(row,index) in runtimeData.page" :key="row.id">
                        <td style="text-align:left;word-break:break-all;">
                            <div>
                                <van-cell title="下单时间" :value="row.orderDate"/>
                                <van-cell title="订单号" :value="row.orderNum"/>
                                <van-cell title="订单状态" :value="row.ext1"/>
                                <van-cell title="是否首单" :value="row.ext2"/>
                                <van-cell title="销售类型" :value="row.ext3"/>
                                <van-cell title="订单类型" :value="row.ext4"/>
                                <van-cell title="商品id" :value="row.ext5"/>
                                <van-cell title="商品名称" :value="row.ext6"/>
                                <van-cell title="支付金额" :value="row.ext7"/>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <van-popup v-model="dateShowStart" position="bottom">
                <van-datetime-picker v-model="currentDateStart" type="datetime" @cancel="handleCancel"
                                     @confirm="handleStartDateConfirm3"/>
            </van-popup>
            <van-popup v-model="dateShow" position="bottom">
                <van-datetime-picker v-model="currentDate" type="datetime" @cancel="handleCancel"
                                     @confirm="handleEndDateConfirm3"/>
            </van-popup>
        </div>
    </div>

</template>

<script>
    import countAPI from '@/api/count'

    export default {
        data() {
            return {
                query: {
                    linkId: this.$route.query.linkId,
                },
                dateShow: false,
                currentDate: new Date(),
                titleTime: null,
                dateShowStart: false,
                titleTimeStart: null,
                currentDateStart: new Date(),
                runtimeData: {}
            }
        },
        methods: {
            handleCancel() {
                this.dateShow = false;
                this.dateShowStart = false;
            },
            //开始时间
            handleStartDateConfirm3() {
                this.dateShowStart = false;
                this.titleTimeStart = this.timeFormat(this.currentDateStart);
                this.querySuNingDetail();
            },
            //结束时间
            handleEndDateConfirm3() {
                this.dateShow = false;
                this.titleTime = this.timeFormat(this.currentDate);
                this.querySuNingDetail();
            },
            timeFormat(datetime) { // 时间格式化 2019-09-08
                var year = datetime.getFullYear();
                var month = (datetime.getMonth() + 1) < 10 ? "0" + (datetime.getMonth() + 1) : (datetime.getMonth() + 1);
                var date = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
                var hour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
                var minute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
                var second = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
                return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
            },

            querySuNingDetail() {
                let queryObj = {};
                if (this.titleTime && this.titleTimeStart && this.query.linkId) {
                    this.$toast.loading({forbidClick: true});
                    queryObj.ext1 = this.titleTimeStart;
                    queryObj.ext2 = this.titleTime;
                    queryObj.ext3 = this.query.linkId;

                    countAPI.suningDetail(queryObj).then((result) => {
                        this.runtimeData = result.data;
                        this.$toast.clear()
                    })
                }
            },
        }
    }
</script>

<style lang="scss" scoped>

    .content {
        padding-top: 2rem;
    }

    .button {
        background-color: #fff;
        margin: 2rem 5%;
        height: 3rem;
        border-radius: 2rem;
        text-align: center;
        line-height: 3rem;
    }

</style>
